import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FilmziWithText = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 638 130"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9669_4271)">
        <path
          d="M80.7885 86.6669H44.3884C43.258 86.6669 42.3537 85.7626 42.3537 84.6321V45.3683C42.3537 44.2379 41.4493 43.3336 40.3189 43.3336H12.6609C11.4551 43.3336 10.3246 43.7857 9.49566 44.6901L1.35652 52.8292C0.527537 53.6582 0 54.864 0 55.9944V127.966C0 129.096 0.904349 130 2.03478 130H41.5247L42.9566 129.397L49.8145 122.539L60.6667 111.687L82.2204 90.1336C83.5015 88.8524 82.5972 86.6669 80.7885 86.6669ZM10.5507 58.4814C10.5507 57.0495 11.7565 55.8437 13.1884 55.8437H28.7884C28.7884 55.8437 29.0899 55.8437 29.1652 55.9191C30.5218 56.0698 31.4261 57.2002 31.4261 58.4814V69.5597H10.5507V58.4814ZM31.4261 79.2061V92.922H10.5507V79.2061H31.4261ZM10.5507 113.571V102.493H31.4261V113.571C31.4261 115.079 30.2957 116.209 28.7884 116.209H13.1884C11.7565 116.209 10.5507 115.079 10.5507 113.571Z"
          fill="url(#paint0_linear_9669_4271)"
        />
        <path
          d="M65.0579 43.3336H101.458C102.588 43.3336 103.493 44.238 103.493 45.3684V84.6322C103.493 85.7626 104.397 86.667 105.527 86.667H133.185C134.391 86.667 135.522 86.2148 136.351 85.3104L144.49 77.1713C145.319 76.3423 145.846 75.1365 145.846 74.0061V2.03503C145.846 0.904593 144.942 0.000244141 143.812 0.000244141H104.322L102.89 0.603143L96.0318 7.46112L85.1796 18.3133L63.626 39.8669C62.3448 41.1481 63.2492 43.3336 65.0579 43.3336ZM135.296 71.5191C135.296 72.951 134.09 74.1568 132.658 74.1568H117.058C117.058 74.1568 116.756 74.1568 116.681 74.0815C115.325 73.9307 114.42 72.8003 114.42 71.5191V60.4409H135.296V71.5191ZM114.42 50.7945V37.0785H135.296V50.7945H114.42ZM135.296 16.4292V27.5075H114.42V16.4292C114.42 14.922 115.551 13.7916 117.058 13.7916H132.658C134.09 13.7916 135.296 14.922 135.296 16.4292Z"
          fill="url(#paint1_linear_9669_4271)"
        />
        <path
          d="M297.35 114.775H283.365C282.388 114.775 281.561 113.948 281.561 112.97V16.9551C281.561 15.9777 282.388 15.1506 283.365 15.1506H297.35C298.327 15.1506 299.155 15.9777 299.155 16.9551V112.97C299.155 113.948 298.327 114.775 297.35 114.775Z"
          fill={fill}
        />
        <path
          d="M317.726 15.0754H331.711C332.689 15.0754 333.516 15.9024 333.516 16.8799V95.3009C333.516 96.2784 334.343 97.1055 335.32 97.1055H388.854C389.832 97.1055 390.659 97.9325 390.659 98.91V112.895C390.659 113.872 389.832 114.699 388.854 114.699H317.726C316.749 114.699 315.922 113.872 315.922 112.895V16.8799C315.922 15.9024 316.749 15.0754 317.726 15.0754Z"
          fill={fill}
        />
        <path
          d="M635.169 114.85H621.184C620.207 114.85 619.38 114.249 619.38 113.497V41.0906C619.38 40.3387 620.207 39.7372 621.184 39.7372H635.169C636.147 39.7372 636.974 40.3387 636.974 41.0906V113.497C636.974 114.249 636.147 114.85 635.169 114.85Z"
          fill={fill}
        />
        <path
          d="M264.493 31.1659V17.1809C264.493 16.2035 263.666 15.3764 262.689 15.3764H187.651C186.674 15.3764 185.847 16.2035 185.847 17.1809V113.196C185.847 114.173 186.674 115 187.651 115H201.636C202.614 115 203.441 114.173 203.441 113.196V74.023H247.651C248.629 74.023 249.456 73.196 249.456 72.2185V58.1584C249.456 57.1809 248.629 56.3538 247.651 56.3538H203.441V33.0456H262.689C263.666 33.0456 264.493 32.2185 264.493 31.2411V31.1659Z"
          fill={fill}
        />
        <path
          d="M603.289 15.2259H536.372C535.695 15.2259 535.094 15.6018 534.718 16.1281L526.673 29.8875C525.921 31.1657 526.823 32.7447 528.327 32.7447H575.169L529.605 111.692C528.853 112.97 529.755 114.549 531.259 114.549H598.327C599.003 114.549 599.605 114.173 599.981 113.572L607.876 99.8876C608.628 98.6094 607.65 97.0304 606.221 97.0304H559.605L605.169 18.083C605.921 16.8048 605.018 15.2259 603.515 15.2259H603.289Z"
          fill={fill}
        />
        <path
          d="M457.801 58.6844L433.364 16.128C432.989 15.4513 432.312 15.0754 431.56 15.0754H407.349C406.146 15.0754 405.244 16.0528 405.244 17.1806V112.293C405.244 113.496 406.222 114.399 407.349 114.399H420.658C421.861 114.399 422.763 113.421 422.763 112.293V34.925L457.725 95.3761C457.725 95.3761 457.801 95.3761 457.876 95.3761L492.763 35.1506H492.913V112.293C492.913 113.496 493.891 114.399 495.019 114.399H508.327C509.53 114.399 510.432 113.421 510.432 112.293V17.1806C510.432 15.9776 509.455 15.0754 508.327 15.0754H484.192C483.44 15.0754 482.763 15.4513 482.387 16.128L457.876 58.6844H457.801Z"
          fill={fill}
        />
        <path
          d="M635.545 32.2934H620.959C619.981 32.2934 619.154 31.4663 619.154 30.4888V16.8046C619.154 15.8272 619.981 15.0001 620.959 15.0001H635.545C636.523 15.0001 637.35 15.8272 637.35 16.8046V30.4888C637.35 31.4663 636.523 32.2934 635.545 32.2934Z"
          fill="url(#paint2_linear_9669_4271)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9669_4271"
          x1="79.4573"
          y1="127"
          x2="9.53382"
          y2="42.2063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C2FAD" />
          <stop offset="1" stopColor="#E249AF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9669_4271"
          x1="142.483"
          y1="83.667"
          x2="72.5592"
          y2="-1.12698"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C2FAD" />
          <stop offset="1" stopColor="#E249AF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9669_4271"
          x1="618.674"
          y1="36.0004"
          x2="645.074"
          y2="9.38903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C2FAD" />
          <stop offset="1" stopColor="#E249AF" />
        </linearGradient>
        <clipPath id="clip0_9669_4271">
          <rect width="637.349" height="130" fill="white" transform="translate(0 0.000244141)" />
        </clipPath>
      </defs>
    </svg>
  );
};

FilmziWithText.displayName = 'FilmziWithText';
